import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { FormErrorList } from "../../../forms/FormErrorList";
import {
    ReactivatedReCaptchaField,
    useReCaptchaSubmit,
} from "../../../forms/ReactivatedReCaptcha";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "../../../forms/classNames";
import { AccountContentTitle } from "../AccountContentTitle";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.ExpiredTokenDocumentTemplate> & {
    /** Site override for the title bar; defaults to the account
     * `AccountContentTitle` (tempurpedic renders its utility-page title). */
    titleBar?: React.ReactNode;
};

export const ExpiredTokenBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        email_sent,
        sent_message,
        intro_message,
        user_value,
        next_value,
        errors,
        action_url,
        submit_text,
    } = props;
    // Hooks must run unconditionally, so resolve the submit handler at the top
    // of the component body (it is only attached in the form state).
    const onSubmit = useReCaptchaSubmit(props.recaptcha_action);
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                {props.titleBar ?? (
                    <AccountContentTitle
                        contentTitle={content_title}
                        phoneDisplay={phone_display}
                        phoneHref={phone_href}
                    />
                )}

                <div className="content__copy--full-width">
                    {email_sent ? (
                        <p>{sent_message}</p>
                    ) : (
                        <>
                            <p>{intro_message}</p>
                            <form
                                className={FORM_CLASS_NAME}
                                method="post"
                                action={action_url}
                                onSubmit={onSubmit}
                            >
                                <CSRFToken />
                                {errors.length > 0 && (
                                    <div className={FORM_FIELD_CLASS_NAME}>
                                        <FormErrorList errors={errors} />
                                    </div>
                                )}
                                <input
                                    type="hidden"
                                    name="user"
                                    value={user_value}
                                />
                                <input
                                    type="hidden"
                                    name="next"
                                    value={next_value}
                                />
                                <ReactivatedReCaptchaField />
                                <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                    <input
                                        type="submit"
                                        className="button button--full-width"
                                        value={submit_text}
                                    />
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
